module.exports = __webpack_public_path__ + "img/15_hmu.35a8d178.jpg";